var map = {
	"../app/portal/portal.module": [
		"./src/app/portal/portal.module.ts",
		"app-portal-portal-module"
	],
	"../app/privacy/privacy.module": [
		"./src/app/privacy/privacy.module.ts",
		"app-privacy-privacy-module"
	],
	"../app/terms/terms.module": [
		"./src/app/terms/terms.module.ts",
		"app-terms-terms-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;